import { Button, Form, Input, message } from "antd";
import { useEffect } from "react";
import { useAppDispatch } from "../../../../app/hooks";
import { ISetState } from "../../../../common/types/commonTypes";
import { setModal } from "../../../../common/slices/commonSlice";
import { AirlineDataType } from "../types/AirlinesTypes";
import { useEditAirlineMutation } from "../Endpoints/airlineEndpoints";
import assyncWrapper from "../../../../common/utils/assyncWrapper";
import LoadingIndicator from "../../../../components/common/spinner/LoadingIndicator";
import { selectUser } from "../../../../auth/states/userSlice";
import { useSelector } from "react-redux";

interface IProps {
  airLineNameList: string[];
  info: AirlineDataType;
  setNull: ISetState<AirlineDataType | null>;
}

const EditAirlineModal = ({ info, setNull, airLineNameList }: IProps) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const user = useSelector(selectUser);

  console.log(info);

  useEffect(() => {
    form.setFieldsValue(info);
  }, [info]);

  const [editAirline, { isError, isSuccess, isLoading }] =
    useEditAirlineMutation();
  useEffect(() => {
    if (isSuccess) {
      message.success("Airline Edited Successfully");
    } else if (isError) {
      message.error("Something went wrong");
    }
  }, [isSuccess, isError]);

  const handleSubmit = async () => {
    assyncWrapper(async () => {
      const values = (await form.getFieldsValue()) as AirlineDataType;
      values.airlines_update_by = user?.user_id as number;

      await editAirline({ body: values, id: info?.airline_id });
      setNull(null);
      dispatch(setModal(false));
    });
  };
  return (
    <Form
      layout="horizontal"
      labelAlign="left"
      form={form}
      labelCol={{ span: 9 }}
      wrapperCol={{ span: 16 }}
      onFinish={handleSubmit}
    >
      <Form.Item
        label="Airline Name"
        name="airline_name"
        rules={[
          { required: false, message: "Please enter Airline name!" },
          { max: 75, message: "Maximum 75 characters" },
          {
            validator(_, value) {
              if (value) {
                if (airLineNameList.includes(value.trim())) {
                  return Promise.reject("AirLine Name is already Exist");
                } else {
                  return Promise.resolve();
                }
              } else {
                return Promise.resolve();
              }
            },
          },
        ]}
      >
        <Input placeholder="Enter Airline name" />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 9, span: 16 }}>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          Update
        </Button>
      </Form.Item>
      {isLoading && <LoadingIndicator />}
    </Form>
  );
};

export default EditAirlineModal;
